export const EMAIL_NOT_VERIFIED_CODE = 'email_not_verified';

export function parseLoginError(data, fallbackEmail = '') {
  const detail = data?.detail;
  if (typeof detail === 'object' && detail?.code === EMAIL_NOT_VERIFIED_CODE) {
    return {
      requiresEmailVerification: true,
      email: detail.email || fallbackEmail,
      message: detail.message || 'Please verify your email before signing in.',
    };
  }
  const message = typeof detail === 'string' ? detail : detail?.message || 'Login failed';
  return { message };
}
